import { gql } from '@apollo/client';

export const FETCH_EVENTS = gql`
  query PlaybookuxEvents($testSessionId: ID!) {
    playbookuxEvents(testSessionId: $testSessionId) {
      name
      data
      createdAt
    }
  }
`;
